import React from 'react';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { Button } from '../Button';
import { formatClassName } from '../../utils';

interface SSOButtonProps {
  className?: string;
  disabled?: boolean;
  fixedSize?: boolean;
  icon?: IconName;
  imgUrl?: string;
  rounded?: boolean;
  label?: string;
  iconFamily?: string;
  [key: string]: unknown;
}

export const SSOButton: React.FC<SSOButtonProps> = ({
  className,
  disabled = false,
  fixedSize = false,
  icon,
  imgUrl,
  rounded = false,
  ...otherProps
}) => {
  const buttonClass = formatClassName([
    className,
    'btn-sso',
    'btn-block',
    'large',
    {
      'fixed-size': fixedSize,
      'with-icon': !!icon,
      'with-image-icon': !!imgUrl,
      rounded,
    },
  ]);

  const buttonStyle =
    imgUrl && !disabled
      ? {
          backgroundImage: `url(${imgUrl})`,
        }
      : undefined;

  return (
    <Button
      {...otherProps}
      style="secondary"
      className={buttonClass}
      cssStyle={buttonStyle}
      icon={imgUrl ? undefined : icon}
      disabled={disabled}
      renderAsLegacy
    />
  );
};
